module.exports = '1.1.1';



/*****************
 ** WEBPACK FOOTER
 ** ./~/sockjs-client/lib/version.js
 ** module id = 216
 ** module chunks = 0
 **/